import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { ROUTES } from '@utils/constants.js'
import type { AppMode } from '@stores/modeStore.js'
import type { NavIconKey } from '@components/layout/navConfig.js'

export type HomeSection = 'guia' | 'obra' | 'app'

export interface HomeScreen {
  to: string
  label: string
  desc: string
  icon: NavIconKey
  section: HomeSection
  mode?: AppMode
  showAlertBadge?: boolean
}

export const HOME_SECTIONS: { id: HomeSection; label: string }[] = [
  { id: 'guia', label: 'Guia' },
  { id: 'obra', label: 'Obra' },
  { id: 'app', label: 'App' },
]

export const HOME_SCREENS: HomeScreen[] = [
  {
    to: ROUTES.MODULOS,
    label: 'Jornada',
    desc: 'Guia da construção',
    icon: 'jornada',
    section: 'guia',
    mode: 'guia',
  },
  {
    to: ROUTES.ETAPA,
    label: GUIA_LABELS.etapaAtual,
    desc: 'O que fazer agora',
    icon: 'etapa',
    section: 'guia',
    mode: 'guia',
  },
  {
    to: ROUTES.CHECKLIST_PENDENTES,
    label: 'Checklists do guia',
    desc: 'Itens sem marcar em etapas que você já passou',
    icon: 'checklist',
    section: 'guia',
    mode: 'guia',
  },
  {
    to: ROUTES.CALCULADORAS,
    label: GUIA_LABELS.ferramentasIndex,
    desc: GUIA_LABELS.ferramentasIndexDesc,
    icon: 'ferramenta',
    section: 'guia',
    mode: 'guia',
  },
  {
    to: ROUTES.WIKI,
    label: 'Enciclopédia',
    desc: 'Conceitos e terminologias',
    icon: 'wiki',
    section: 'guia',
    mode: 'guia',
  },
  {
    to: ROUTES.PAINEL,
    label: 'Painel da obra',
    desc: 'Fase, finanças e resumo',
    icon: 'obra',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.FINANCEIRO,
    label: 'Financeiro',
    desc: 'O que saiu da conta. Cotação e parcela paga caem aqui.',
    icon: 'financeiro',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.CONTRATOS,
    label: 'Contratos e pagamentos',
    desc: 'Pague por serviço medido, não por data',
    icon: 'contratos',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.CRONOGRAMA,
    label: 'Cronograma',
    desc: 'Fases, prazos e avanço da obra',
    icon: 'cronograma',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.DECISOES,
    label: 'Memorial de decisões',
    desc: 'O que já travou e não dá para mudar',
    icon: 'decisoes',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.MATERIAIS,
    label: 'Materiais',
    desc: 'Compare preço. Escolher lança no Financeiro.',
    icon: 'materiais',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.DOCUMENTOS,
    label: 'Arquivos',
    desc: 'Contratos, NFs e laudos. Foto do dia fica no Diário.',
    icon: 'documentos',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.DIARIO,
    label: 'Diário',
    desc: 'Foto, clima e o que aconteceu. Prova da obra.',
    icon: 'diario',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.PENDENCIAS,
    label: 'Tarefas',
    desc: 'Sua lista do canteiro. Não é checklist do guia.',
    icon: 'pendencias',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.CONTATOS,
    label: 'Contatos da obra',
    desc: 'Equipe, profissionais e fornecedores',
    icon: 'contatos',
    section: 'obra',
    mode: 'obra',
  },
  {
    to: ROUTES.ALERTAS,
    label: 'Alertas',
    desc: 'O app avisa sozinho: orçamento, atraso, NF',
    icon: 'alertas',
    section: 'app',
    showAlertBadge: true,
  },
  {
    to: ROUTES.CONFIG,
    label: 'Configurações',
    desc: 'Dados da obra e backup',
    icon: 'config',
    section: 'app',
  },
]
